import { Price } from '@salsita-ai/platform-project-sdk/ui'

interface PriceFooterProps {
  price: number
}

export const PriceFooter = ({ price }: PriceFooterProps) => (
  <Price label="Total Price" value={`$${price}`} direction="row" />
)
